// Environment configuration with type safety: typed reads of the build-time
// env, which Vite inlines. Every name is in the web-build schema
// (lib/env-schema.ts) that production builds check (CONFIG CF-8).
export const env = {
  API_URL: import.meta.env.VITE_API_BASE_URL as string,
  APP_ENV: import.meta.env.VITE_APP_ENV as 'development' | 'staging' | 'production' | 'preview',
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL as string,
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined,
  GOOGLE_MAPS_MAP_ID: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID as string | undefined,
} as const;
